import { useContext, useState, useEffect } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import { Link } from "react-router-dom";
import Pagination from "../../components/Pagination";
import { notificationService } from "../../services/notificationService";
import { cityService } from "../../services/cityService";
import Loading from "../../components/common/Loading";
import { toast } from "../../services/toastService";
import { params } from "../../config/params";
import { searchParams } from "../../config/searchParams";

const emptyFilters = {
  isRead: "",
  cityId: "",
  dateFrom: "",
  dateTo: "",
  minRevenue: "",
  maxRevenue: "",
};

const Notifications = () => {
  const { t, lang } = useContext(LocaleContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [cities, setCities] = useState([]);
  const [filters, setFilters] = useState(emptyFilters);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    setLoading(true);
    getAllAsync();
    loadCities();
  }, []);

  const loadCities = async () => {
    try {
      const result = await cityService.getDropdownAsync();
      setCities(result || []);
    } catch (err) {
      console.error(err);
    }
  };

  const buildParams = (extraFilters = filters) => {
    const merged = { ...params };
    if (extraFilters.isRead !== "") merged.isRead = extraFilters.isRead === "true";
    if (extraFilters.cityId) merged.cityId = extraFilters.cityId;
    if (extraFilters.dateFrom) merged.dateFrom = extraFilters.dateFrom;
    if (extraFilters.dateTo) merged.dateTo = extraFilters.dateTo;
    if (extraFilters.minRevenue !== "") merged.minRevenue = Number(extraFilters.minRevenue);
    if (extraFilters.maxRevenue !== "") merged.maxRevenue = Number(extraFilters.maxRevenue);
    return merged;
  };

  const getAllAsync = async (extraFilters = filters) => {
    try {
      const result = await notificationService.getAllAsync(buildParams(extraFilters));
      setData(result);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getAllSearchAsync = async (signal) => {
    try {
      const result = await notificationService.getAllSearchAsync(searchParams, signal);
      setData(result);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (search.trim().length < 2) {
      params.pageNumber = 1;
      getAllAsync();
      return;
    }
    const controller = new AbortController();
    const delay = setTimeout(() => {
      searchParams.search = search.trim();
      searchParams.pageNumber = 1;
      getAllSearchAsync(controller.signal);
    }, 400);
    return () => {
      controller.abort();
      clearTimeout(delay);
    };
  }, [search]);

  const onPageChange = async (pageNumber) => {
    setLoading(true);
    if (!search) {
      params.pageNumber = pageNumber;
      getAllAsync();
      return;
    }
    searchParams.pageNumber = pageNumber;
    await getAllSearchAsync();
  };

  const applyFilters = () => {
    params.pageNumber = 1;
    setLoading(true);
    setShowFilters(false);
    getAllAsync(filters);
  };

  const clearFilters = () => {
    setFilters(emptyFilters);
    params.pageNumber = 1;
    setLoading(true);
    getAllAsync(emptyFilters);
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <>
      {loading && <Loading />}
      <section className="section-notifications">
        <div className="default-heading">{t("notifications")}</div>
        <section className="section-dashboard-cards mb-3 d-none">
          <div className="row">
            <div className="col-12 col-md-3">
              <div className="d-card d-card-primary">
                <div className="d-card-header">{t("totalUsers")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-card d-card-dark">
                <div className="d-card-header">{t("onlineUsers")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-card d-card-primary">
                <div className="d-card-header">{t("client")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-card d-card-dark">
                <div className="d-card-header">{t("totalRevenue")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section-grid">
          <div className="grid-card">
            <div className="grid-card-header">
              <strong>{t("notificationManagement")}</strong>
              <p>{t("viewAndManageAllNotificationsInTheSystem")}</p>
            </div>
            <div className="grid-card-body">
              <div className="table-header">
                <div className="table-header-icons hidden">
                  <div className="icon-box"><i className="fas fa-file-pdf"></i></div>
                  <div className="icon-box"><i className="fas fa-file-excel"></i></div>
                  <div className="icon-box"><i className="fas fa-print"></i></div>
                </div>
                <div className="table-search">
                  <div className="input-icon input-icon-width">
                    <input
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="form-control input-search"
                      placeholder={t("search")}
                    />
                    <i className="fas fa-search"></i>
                  </div>
                  <div className="grid-btn">
                    <Link to="/notification-form">
                      <button className="btn-default my-bg-secondary">
                        <i className="fas fa-plus"></i> {t("addNewNotification")}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-delete-option mt-3">
                <b>{t("allNotifications")}</b>
                <div className="d-flex align-items-center gap-2">
                  <i
                    className="fas fa-filter cursor-pointer"
                    onClick={() => setShowFilters((v) => !v)}
                  />
                  <span></span>
                </div>
              </div>
              {showFilters && (
                <div className="p-3 border rounded mb-3 bg-white">
                  <div className="row g-2">
                    <div className="col-12 col-md-3">
                      <label className="form-label fw-bold">{t("status")}</label>
                      <select
                        className="form-control form-control-sm"
                        value={filters.isRead}
                        onChange={(e) => handleFilterChange("isRead", e.target.value)}
                      >
                        <option value="">{t("all")}</option>
                        <option value="true">{t("read")}</option>
                        <option value="false">{t("unRead")}</option>
                      </select>
                    </div>
                    <div className="col-12 col-md-3">
                      <label className="form-label fw-bold">{t("city")}</label>
                      <select
                        className="form-control form-control-sm"
                        value={filters.cityId}
                        onChange={(e) => handleFilterChange("cityId", e.target.value)}
                      >
                        <option value="">{t("all")}</option>
                        {cities.map((city) => (
                          <option key={city.id} value={city.id}>
                            {city.name?.[lang]}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-md-3">
                      <label className="form-label fw-bold">{t("date")}</label>
                      <input
                        type="date"
                        className="form-control form-control-sm mb-1"
                        value={filters.dateFrom}
                        onChange={(e) => handleFilterChange("dateFrom", e.target.value)}
                      />
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={filters.dateTo}
                        onChange={(e) => handleFilterChange("dateTo", e.target.value)}
                      />
                    </div>
                    <div className="col-12 col-md-3">
                      <label className="form-label fw-bold">{t("revenues")}</label>
                      <input
                        type="number"
                        className="form-control form-control-sm mb-1"
                        value={filters.minRevenue}
                        onChange={(e) => handleFilterChange("minRevenue", e.target.value)}
                        placeholder={t("min")}
                      />
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={filters.maxRevenue}
                        onChange={(e) => handleFilterChange("maxRevenue", e.target.value)}
                        placeholder={t("max")}
                      />
                    </div>
                    <div className="col-12 d-flex gap-2 justify-content-end">
                      <button className="btn-default" onClick={applyFilters}>
                        {t("search")}
                      </button>
                      <button className="btn-secondary" onClick={clearFilters}>
                        {t("cancel")}
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="my-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th><input type="checkbox" /></th>
                      <th>{t("code")}</th>
                      <th>{t("userName")}</th>
                      <th>{t("message")}</th>
                      <th>{t("date")}</th>
                      <th>{t("actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.items &&
                      data.items.map((item) => (
                        <tr key={item.id}>
                          <td><input type="checkbox" /></td>
                          <td>{item.code}</td>
                          <td>{item.userName}</td>
                          <td>{item.message}</td>
                          <td>{item.createdAt?.toDate()}</td>
                          <td>
                            <i className="fas fa-ellipsis-vertical" data-bs-toggle="dropdown" aria-expanded="false"></i>
                            <ul className="dropdown-menu">
                              <li>
                                <a className="dropdown-item" href={`/notification-form/${item.id}`}>
                                  <i className="fas fa-edit"></i> {t("edit")}
                                </a>
                              </li>
                              <li>
                                <Link className="dropdown-item" to={`/notification-details/${item.id}`}>
                                  <i className="fas fa-eye"></i> {t("view")}
                                </Link>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))}
                    {data?.items?.length === 0 && (
                      <tr>
                        <td colSpan="100%" className="text-center py-3">
                          {t("noResultsFound")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="grid-footer">
              {data && (
                <Pagination
                  t={t}
                  pageNumber={data.pageNumber}
                  totalPages={data.totalPages}
                  hasNextPage={data.hasNextPage}
                  hasPreviousPage={data.hasPreviousPage}
                  onPageChange={onPageChange}
                />
              )}
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default Notifications;
